export default __webpack_public_path__ + "static/media/404.bef58a20.svg";